<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="about-page">
    <Header light />
    <section class="about-banner" :style="bannerStyle" aria-label="公司简介"></section>
    <main class="about-main">
      <section class="about-intro-layout">
        <div class="about-intro-media">
          <div class="about-intro-main-image">
            <img src="/images/CompanyProfile/CompanyProfile1.jpg" alt="鑫谷程序员教学场景" />
          </div>
        </div>
        <div class="about-intro-copy">
          <h2>公司简介</h2>
          <p class="about-intro-lead">数据智能，无限可能</p>
          <p>{{ introduction[0] }}</p>
        </div>
        <div class="about-intro-details">
          <p v-for="paragraph in introduction.slice(1)" :key="paragraph">{{ paragraph }}</p>
        </div>
      </section>
      <section class="about-values">
        <div class="about-values-heading">
          <!-- <span>02 / BRAND VALUES</span> -->
          <h2>品牌文化</h2>
        </div>
        <div class="about-value-grid">
          <article v-for="item in values" :key="item.title" class="about-value-card">
            <small>{{ item.label }}</small>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </article>
        </div>
      </section>
    </main>
    <Footer />
  </div>
</template>
<script setup>
import Header from "../components/layout/Header.vue";
import Footer from "../components/layout/Footer.vue";
import "../assets/css/About.css";

const introduction = [
  "鑫谷程序员始创于2011年，是国内深耕数字技术领域十余年的专业IT教育品牌。企业始终紧跟国家数字经济发展战略，以“实战就业为导向、前沿技术为核心”，专注于为全国技术从业者、求职人群提供专业的技能进阶与就业赋能服务。",
  "公司业务布局完善，现已形成软件开发、技术进阶指导、高校实训共建、企业技术服务四大核心板块。业务版图辐射全国，在北京、山东、江苏等地设立多家分支机构，全国化布局持续深化。",
  "依托深厚的行业积累，我们搭建了完整的技术人才培养课程体系，涵盖Java开发、AI运维、AI智能应用开发、AI大模型开发、AI设计与剪辑等当下主流前沿技术方向，精准匹配行业用人需求。",
  "在教学研发与师资建设上，团队汇聚行业技术精英与资深授课名师，结合就业数据持续迭代课程内容，按照职业方向、专业领域、能力等级搭建标准化培训体系，以企业级实战项目贯穿教学全流程。",
  "凭借过硬的教学品质与行业资源，我们已与浪潮、海尔、华为等百余家头部IT企业达成深度生态合作，同时配备专业就业指导团队，从职业规划、岗位推荐到入职跟进提供全流程服务。",
  "办学至今，公司年均培养泛IT专业人才千余名，持续为互联网及科技行业输送优质技术力量。课程全线采用纯线下高品质面授教学模式，实训项目同步一线企业技术标准。",
];
const values = [
  { label: "SLOGAN", title: "真正以就业为导向的IT教育", desc: "站在学员发展角度规划学习路径，依托完整实战教学与就业配套服务，用真实就业成果证明教育价值。" },
  { label: "BRAND MISSION", title: "让每一份努力都有方向", desc: "让零基础者入门有道，让职场从业者进阶有成，为互联网行业输送高素质实战型技术人才。" },
  { label: "BRAND VISION", title: "成为值得信赖的人才培养标杆", desc: "持续打磨课程与教学服务，以技术实力、教学品质与就业保障打造可信赖的IT教育品牌。" },
  { label: "SERVICE", title: "以技术立本，以实训提质，以就业护航", desc: "坚守技术教育核心，以企业级实战项目锤炼能力，坚持高品质教学，全流程保障学员职业发展。" },
];

const bannerStyle = {
  backgroundImage: 'url("/images/CompanyProfile/Banner.jpg")',
};
</script>
